import { createStyles, Theme, withStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import * as React from 'react';
import { PresetType, ViewModeType } from '../../store/types';
import { thisMonth, thisWeek, thisYear, today } from '../../viewModes/utils';

export interface PresetsProps {
  preset: PresetType;
}

export interface PresetsActions {
  setRangeAndViewMode: (startDate: Date, endDate: Date, viewModeType: ViewModeType) => void;
  setPreset: (preset: PresetType) => void;
}

interface StylesProps {
  classes: {
    paper: string;
    tab: string;
    tabs: string;
  };
}

interface Preset {
  type: PresetType;
  label: string;
  viewMode: ViewModeType;
  getDate: () => { startDate: Date; endDate: Date };
}

const presetsCollection: Preset[] = [
  {
    type: PresetType.Year,
    label: 'YEAR',
    viewMode: ViewModeType.Months,
    getDate: thisYear
  },
  {
    type: PresetType.Month,
    label: 'MONTH',
    viewMode: ViewModeType.Days,
    getDate: thisMonth
  },
  {
    type: PresetType.Week,
    label: 'WEEK',
    viewMode: ViewModeType.Days,
    getDate: thisWeek
  },
  {
    type: PresetType.Day,
    label: 'DAY',
    viewMode: ViewModeType.Hours,
    getDate: today
  },
  {
    type: PresetType.Custom,
    label: 'CUSTOM',
    viewMode: ViewModeType.Weeks,
    getDate: () => ({
      startDate: new Date(),
      endDate: new Date()
    })
  }
];

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      marginLeft: theme.spacing(2)
    },
    tab: {
      minWidth: 0,
      minHeight: 33
    },
    tabs: {
      minHeight: 33
    }
  });

class Presets extends React.PureComponent<PresetsProps & PresetsActions & StylesProps> {
  public componentDidMount() {
    const preset = presetsCollection.find(p => p.type === this.props.preset);

    if (preset) {
      const { startDate, endDate } = preset.getDate();
      this.props.setRangeAndViewMode(startDate, endDate, preset.viewMode);
    }
  }

  private tabChanged = (e: React.ChangeEvent<HTMLElement>, value: number) => {
    this.presetSelected(presetsCollection[value]);
  };

  private presetSelected = (p: Preset) => {
    const { preset, setPreset, setRangeAndViewMode } = this.props;
    const { startDate, endDate } = p.getDate();

    if (p.type === preset) {
      return;
    }

    setPreset(p.type);

    if (p.type !== PresetType.Custom) {
      setRangeAndViewMode(startDate, endDate, p.viewMode);
    }
  };

  public render() {
    return (
      <Paper elevation={1} className={this.props.classes.paper}>
        <Tabs
          className={this.props.classes.tabs}
          indicatorColor="primary"
          textColor="primary"
          value={presetsCollection.map(p => p.type).indexOf(this.props.preset)}
          onChange={this.tabChanged}
        >
          {presetsCollection.map((preset, i) => (
            <Tab key={i} label={preset.label} className={this.props.classes.tab} />
          ))}
        </Tabs>
      </Paper>
    );
  }
}
export default withStyles(styles)(Presets);



// WEBPACK FOOTER //
// ./src/components/navbar/Presets.tsx